var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpBtnPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_192_17805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_192_17805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7916 34.3748L34.375 24.9998L19.7916 15.6248V34.3748ZM25 45.8332C22.118 45.8332 19.4097 45.2863 16.875 44.1925C14.3402 43.0988 12.1354 41.6144 10.2604 39.7394C8.38538 37.8644 6.901 35.6596 5.80725 33.1248C4.7135 30.5901 4.16663 27.8818 4.16663 24.9998C4.16663 22.1179 4.7135 19.4096 5.80725 16.8748C6.901 14.3401 8.38538 12.1353 10.2604 10.2603C12.1354 8.38525 14.3402 6.90088 16.875 5.80713C19.4097 4.71338 22.118 4.1665 25 4.1665C27.8819 4.1665 30.5902 4.71338 33.125 5.80713C35.6597 6.90088 37.8645 8.38525 39.7395 10.2603C41.6145 12.1353 43.0989 14.3401 44.1927 16.8748C45.2864 19.4096 45.8333 22.1179 45.8333 24.9998C45.8333 27.8818 45.2864 30.5901 44.1927 33.1248C43.0989 35.6596 41.6145 37.8644 39.7395 39.7394C37.8645 41.6144 35.6597 43.0988 33.125 44.1925C30.5902 45.2863 27.8819 45.8332 25 45.8332Z",
    fill: "#FFBE10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpBtnPlay);
export default __webpack_public_path__ + "static/media/whp-btn-play.991143644573c28c1b851c55452b3a61.svg";
export { ForwardRef as ReactComponent };